import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { FormatAmount } from "@portal/helpers";
import { IOngoingCostsProps } from "../types";

export const OngoingCosts = ({ title, isDefaultLanguage, managementFee, depotFee, summedFee }: IOngoingCostsProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="flex flex-col my-3 p-3 border dark:border-blueBorderDark bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark rounded-md">
      <div className="flex w-full flex-row justify-between">
        <Typography variant="Bold">{title}</Typography>
        <Typography variant="Bold">{texts.PAGE_15_PRICE}</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_COMMISIONER}</Typography>
        <Typography>{FormatAmount(managementFee ?? 0)},-</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_TRANSACTION_COST}</Typography>
        <Typography>{0},-</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_COST_BANK}</Typography>
        <Typography>{FormatAmount(depotFee ?? 0)},-</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_TOTAL_COST}</Typography>
        <Typography>{FormatAmount(summedFee ?? 0)},-</Typography>
      </div>
    </div>
  );
};
